const state = {
  colors: []
}

const mutations = {
  MAP_COLORS (state, colors) {
    state.colors = colors
  }
}

const actions = {
  map ({ commit }, colors) {
    commit('MAP_COLORS', colors)
  }
}

export default { namespaced: true, state, mutations, actions }
